import React, { Component } from "react";
import { MDBBtn } from "mdb-react-ui-kit";

export default class FileBase64Input extends Component {
  inputRef = React.createRef();

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const res = String(reader.result || "");
        const base64 = res.includes(";base64,") ? res.split(";base64,")[1] : res;
        resolve({ base64, dataUrl: res });
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  onPick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const { base64, dataUrl } = await this.toBase64(file);
    this.props.onBase64?.(base64, dataUrl, file);
  };

  render() {
    const { label = "Subir imagen" } = this.props;
    return (
      <div className="file-b64">
        <input
          ref={this.inputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={this.onPick}
        />
        <MDBBtn size="sm" color="secondary" onClick={() => this.inputRef.current?.click()}>
          {label}
        </MDBBtn>
      </div>
    );
  }
}
